// import React, { useState, useEffect } from 'react';
// import {
//   Button,
//   Typography,
//   AppBar,
//   Toolbar,
//   Paper,
//   makeStyles,
//   Grid,
//   Box,
//   CircularProgress,
//   Container
// } from "@material-ui/core";
// import { Link } from "react-router-dom";
// import '../assets/styles/PreConEmail.css';
// import Breadcrumb from "./BreadcrumbsComponent"; // Importing styles
// const useStyles = makeStyles((theme) => ({
//   appBar: {
//     marginBottom: theme.spacing(0),
//   },
//   button: {
//     backgroundColor: '#1976d2',
//     color: 'white',
//     '&:hover': {
//       backgroundColor: '#1565c0',
//     },
//   },
//   imagePaper: {
//     padding: theme.spacing(2),
//     marginBottom: theme.spacing(4),
//   },
//   image: {
//     display: 'block',
//     width: "100%",
//     height: "auto",
//     maxWidth: "100%",
//   },
//   loading: {
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     height: '100vh',
//   }
// }));
// const PreConPreview = () => {
//   const classes = useStyles();
//
//   const [loading, setLoading] = useState(true);
//
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setLoading(false);
//     }, 1500); // 1.5 seconds
//
//     return () => clearTimeout(timer); // Clear timeout if the component is unmounted
//   }, []);
//
//   const images = [
//     "../src/assets/images/Precon_2.png",
//     "../src/assets/images/Precon_4.png",
//     "../src/assets/images/Precon_2_copy.png",
//     "../src/assets/images/Precon_3.png",
//     "../src/assets/images/Precon_5.png",
//     "../src/assets/images/Precon_5_copy.png",
//     "../src/assets/images/Precon_6.png",
//     "../src/assets/images/Precon_7.png",
//     "../src/assets/images/Precon_8.png",
//     "../src/assets/images/Precon_9.png",
//     "../src/assets/images/Precon_10.png",
//     "../src/assets/images/Precon_11.png",
//     // ... add more image paths as needed
//   ];
//
// return (
//   <Container>
//     <Grid container spacing={3}>
//       <Breadcrumb />
//     </Grid>
//
//     <div style={{marginTop: "40px"}}>
//
//
//
//     {loading ? (
//       <div className={classes.loading}>
//         <CircularProgress />
//       </div>
//     ) : (
//       <Grid container justifyContent="center">
//         <Grid item xs={12} sm={10} md={8} lg={6}>
//           <AppBar position="static" color="primary" className={classes.appBar}>
//             <Toolbar>
//               <Typography variant="h6" color="inherit">
//                 Preconstruction Preview Page
//               </Typography>
//               <Box flexGrow={1} />
//               <Button
//                 variant="contained"
//                 component={Link}
//                 to="/smart-marketing/E-mail/precon"
//                 className={classes.button}
//                 color="secondary"
//               >
//                 Return to Design
//               </Button>
//             </Toolbar>
//           </AppBar>
//           <Box className={classes.imagePaper}>
//             {images.map((image, index) => (
//               <Paper className={classes.imagePaper} elevation={3} key={index}>
//                 <img
//                   src={image}
//                   alt={`Preview ${index}`}
//                   className={classes.image}
//                 />
//               </Paper>
//             ))}
//           </Box>
//         </Grid>
//       </Grid>
//     )}
//       </div>
//   </Container>
// );
//
// };
//
// export default PreConPreview;
//
import React, { useState, useEffect } from 'react';
import {
  Button,
  Typography,
  AppBar,
  Toolbar,
  Paper,
  makeStyles,
  Grid,
  Box,
  CircularProgress,
  Container
} from "@material-ui/core";
import { Link } from "react-router-dom";
import '../assets/styles/PreConEmail.css';
import Breadcrumb from "./BreadcrumbsComponent"; // Importing styles
const useStyles = makeStyles((theme) => ({
  appBar: {
    marginBottom: theme.spacing(0),
  },
  button: {
    backgroundColor: '#1976d2',
    color: 'white',
    '&:hover': {
      backgroundColor: '#1565c0',
    },
  },
  imagePaper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
  image: {
    display: 'block',
    width: "100%",
    height: "auto",
    maxWidth: "100%",
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
  }
}));
const PreConPreview = () => {
  const classes = useStyles();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500); // 1.5 seconds

    return () => clearTimeout(timer); // Clear timeout if the component is unmounted
  }, []);

  const images = [
    "../src/assets/images/Precon_2.png",
    "../src/assets/images/Precon_4.png",
    "../src/assets/images/Precon_2_copy.png",
    "../src/assets/images/Precon_3.png",
    "../src/assets/images/Precon_5.png",
    "../src/assets/images/Precon_5_copy.png",
    "../src/assets/images/Precon_6.png",
    "../src/assets/images/Precon_7.png",
    "../src/assets/images/Precon_8.png",
    "../src/assets/images/Precon_9.png",
    "../src/assets/images/Precon_10.png",
    "../src/assets/images/Precon_11.png",
    // ... add more image paths as needed
  ];

return (
  <div>

    <div style={{marginTop: "40px"}}>

    {loading ? (
      <div className={classes.loading}>
        <CircularProgress />
      </div>
    ) : (
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={10} md={8} lg={6}>
          <Box className={classes.imagePaper}>
            {images.map((image, index) => (
              <Paper className={classes.imagePaper} elevation={3} key={index}>
                <img
                  src={image}
                  alt={`Preview ${index}`}
                  className={classes.image}
                />
              </Paper>
            ))}
          </Box>
        </Grid>
      </Grid>
    )}
      </div>
  </div>
);

};

export default PreConPreview;

